module.exports = __webpack_public_path__ + "assets/svg/Icons/32/settings-blue-1084a9.svg";